/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AccountUpdateInput,
  Check,
  CheckInput,
  ConfirmAccountInput,
  DestroyAccountParams,
  SchemaValidationErrorResponse,
  StandardError,
  StandardMessage,
  User,
  UserCreateInput,
  UserUpdateInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Update My Account
 */
export const updateAccount = (
    accountUpdateInput: MaybeRefOrGetter<AccountUpdateInput>,
 signal?: AbortSignal
) => {
      accountUpdateInput = toValue(accountUpdateInput);

      return axiosClient<User>(
      {url: `/users/account`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accountUpdateInput, signal
    },
      );
    }




export const getUpdateAccountMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: AccountUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: AccountUpdateInput}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {data: AccountUpdateInput}> = (props) => {
          const {data} = props ?? {};

          return  updateAccount(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = AccountUpdateInput
    export type UpdateAccountMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Update My Account
 */
export const useUpdateAccount = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: AccountUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {data: AccountUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary Check E-Mail Availability
 */
export const checkEmail = (
    checkInput: MaybeRefOrGetter<CheckInput>,
 signal?: AbortSignal
) => {
      checkInput = toValue(checkInput);

      return axiosClient<Check>(
      {url: `/users/check-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInput, signal
    },
      );
    }




export const getCheckEmailMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkEmail>>, TError,{data: CheckInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkEmail>>, TError,{data: CheckInput}, TContext> => {

const mutationKey = ['checkEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkEmail>>, {data: CheckInput}> = (props) => {
          const {data} = props ?? {};

          return  checkEmail(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckEmailMutationResult = NonNullable<Awaited<ReturnType<typeof checkEmail>>>
    export type CheckEmailMutationBody = CheckInput
    export type CheckEmailMutationError = ErrorType<SchemaValidationErrorResponse>

    /**
 * @summary Check E-Mail Availability
 */
export const useCheckEmail = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkEmail>>, TError,{data: CheckInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkEmail>>,
        TError,
        {data: CheckInput},
        TContext
      > => {
      return useMutation(getCheckEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Check Username Availability
 */
export const checkUsername = (
    checkInput: MaybeRefOrGetter<CheckInput>,
 signal?: AbortSignal
) => {
      checkInput = toValue(checkInput);

      return axiosClient<Check>(
      {url: `/users/check-username`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkInput, signal
    },
      );
    }




export const getCheckUsernameMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkUsername>>, TError,{data: CheckInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkUsername>>, TError,{data: CheckInput}, TContext> => {

const mutationKey = ['checkUsername'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkUsername>>, {data: CheckInput}> = (props) => {
          const {data} = props ?? {};

          return  checkUsername(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckUsernameMutationResult = NonNullable<Awaited<ReturnType<typeof checkUsername>>>
    export type CheckUsernameMutationBody = CheckInput
    export type CheckUsernameMutationError = ErrorType<SchemaValidationErrorResponse>

    /**
 * @summary Check Username Availability
 */
export const useCheckUsername = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkUsername>>, TError,{data: CheckInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkUsername>>,
        TError,
        {data: CheckInput},
        TContext
      > => {
      return useMutation(getCheckUsernameMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirm Account
 */
export const confirmAccount = (
    confirmAccountInput: MaybeRefOrGetter<ConfirmAccountInput>,
 signal?: AbortSignal
) => {
      confirmAccountInput = toValue(confirmAccountInput);

      return axiosClient<StandardMessage>(
      {url: `/users/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmAccountInput, signal
    },
      );
    }




export const getConfirmAccountMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAccount>>, TError,{data: ConfirmAccountInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmAccount>>, TError,{data: ConfirmAccountInput}, TContext> => {

const mutationKey = ['confirmAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAccount>>, {data: ConfirmAccountInput}> = (props) => {
          const {data} = props ?? {};

          return  confirmAccount(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmAccountMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAccount>>>
    export type ConfirmAccountMutationBody = ConfirmAccountInput
    export type ConfirmAccountMutationError = ErrorType<ValidationError>

    /**
 * @summary Confirm Account
 */
export const useConfirmAccount = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAccount>>, TError,{data: ConfirmAccountInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmAccount>>,
        TError,
        {data: ConfirmAccountInput},
        TContext
      > => {
      return useMutation(getConfirmAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Account
 */
export const destroyAccount = (
    params?: MaybeRefOrGetter<DestroyAccountParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<StandardMessage>(
      {url: `/users/me`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDestroyAccountMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,{params?: DestroyAccountParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,{params?: DestroyAccountParams}, TContext> => {

const mutationKey = ['destroyAccount'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAccount>>, {params?: DestroyAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  destroyAccount(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAccountMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAccount>>>

    export type DestroyAccountMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Destroy Account
 */
export const useDestroyAccount = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAccount>>, TError,{params?: DestroyAccountParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAccount>>,
        TError,
        {params?: DestroyAccountParams},
        TContext
      > => {
      return useMutation(getDestroyAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary My Data
 */
export const me = (

 signal?: AbortSignal
) => {


      return axiosClient<User>(
      {url: `/users/me`, method: 'GET', signal
    },
      );
    }




export const getMeQueryKey = () => {
    return [
    'users','me'
    ] as const;
    }


export const getMeQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>
}

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeQueryError = ErrorType<StandardError>


/**
 * @summary My Data
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update My Data
 */
export const updateProfile = (
    userUpdateInput: MaybeRefOrGetter<UserUpdateInput>,
 signal?: AbortSignal
) => {
      userUpdateInput = toValue(userUpdateInput);

      return axiosClient<User>(
      {url: `/users/me`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdateInput, signal
    },
      );
    }




export const getUpdateProfileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UserUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UserUpdateInput}, TContext> => {

const mutationKey = ['updateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, {data: UserUpdateInput}> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = UserUpdateInput
    export type UpdateProfileMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update My Data
 */
export const useUpdateProfile = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,{data: UserUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        {data: UserUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }
    /**
 * @summary Create new User
 */
export const signup = (
    userCreateInput: MaybeRefOrGetter<UserCreateInput>,
 signal?: AbortSignal
) => {
      userCreateInput = toValue(userCreateInput);

      return axiosClient<User>(
      {url: `/users/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userCreateInput, signal
    },
      );
    }




export const getSignupMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: UserCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: UserCreateInput}, TContext> => {

const mutationKey = ['signup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signup>>, {data: UserCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  signup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupMutationResult = NonNullable<Awaited<ReturnType<typeof signup>>>
    export type SignupMutationBody = UserCreateInput
    export type SignupMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create new User
 */
export const useSignup = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signup>>, TError,{data: UserCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof signup>>,
        TError,
        {data: UserCreateInput},
        TContext
      > => {
      return useMutation(getSignupMutationOptions(options), queryClient);
    }
